import React from 'react'

const SvgEmailFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.043 5.454l8.544 8.55c.47.389.941.583 1.413.583.472 0 .943-.193 1.415-.581L21.96 5.47c.027.163.041.34.041.529v12c0 1.333-.667 2-2 2H4c-1.333 0-2-.667-2-2V6a3.2 3.2 0 01.043-.546zm1.414-1.411A3.18 3.18 0 014 4h16c.194 0 .373.014.539.042L12 12.588 3.457 4.043z'
    />
  </svg>
)

export default SvgEmailFilled
